module.exports = __webpack_public_path__ + "static/img/exploit1.d3ced532.png";